export default "__VITE_ASSET__dvfBkY1G__"